module.exports = __webpack_public_path__ + "static/media/SLUU.caad7251.png";